import axios from 'axios'
import { AccountDataUtil, AccountDetails, HostEvent } from '../components/Customer/Data'

export async function getHostEvents(teamID: string, hostID: string, signal: AbortSignal): Promise<HostEvent[]> {
  const result = await axios.get('/api/teams/' + teamID + '/hosts/' + hostID + '/events', { signal: signal })

  return Promise.resolve(result.data)
}

export async function getHostAccountDetails(
  teamID: string,
  hostID: string,
  signal: AbortSignal
): Promise<AccountDetails> {
  const resp = await axios.get('/api/teams/' + teamID + '/customers/' + hostID + '/account', { signal: signal })

  return Promise.resolve(AccountDataUtil.getAccountDetailsFromResponse(resp.data))
}
